var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { "no-padding": "" } }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "Subheader",
            {
              attrs: { title: "Depth / Height Datums", search: "data" },
              model: {
                value: _vm.search,
                callback: function ($$v) {
                  _vm.search = $$v
                },
                expression: "search",
              },
            },
            [
              _c(
                "v-btn",
                {
                  attrs: { dark: "", color: "success" },
                  on: {
                    click: function ($event) {
                      _vm.showAddDatumDialog = !_vm.showAddDatumDialog
                    },
                  },
                },
                [
                  _c("v-icon", [_vm._v("add")]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("Button.AddDatum")) +
                      "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.datumList,
                  pagination: _vm.pagination,
                  search: _vm.search,
                },
                on: {
                  "update:pagination": function ($event) {
                    _vm.pagination = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.DatumType.Name)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.DatumName)),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.DatumDescription)),
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "primary" },
                            on: {
                              click: function ($event) {
                                _vm.datumDetail = props.item
                                _vm.showEditDatumDialog =
                                  !_vm.showEditDatumDialog
                              },
                            },
                          },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("edit"),
                            ]),
                            _vm._v(
                              _vm._s(_vm.$t("Button.EditDatum")) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: { color: "error" },
                            on: {
                              click: function ($event) {
                                _vm.dialog = true
                                _vm.deleteDatumName = props.item.DatumName
                                _vm.getDeleteDatumDetails()
                              },
                            },
                          },
                          [
                            _c("v-icon", { staticClass: "mr-1" }, [
                              _vm._v("delete_forever"),
                            ]),
                            _vm._v(
                              _vm._s(_vm.$t("Button.DeleteDatum")) +
                                "\n          "
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          !_vm.isLoading
            ? _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c("v-toolbar-title", [_vm._v("Delete Datum")]),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", dark: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-title", { staticClass: "headline" }, [
                    _vm._v(_vm._s(_vm.datumDeleteText) + " "),
                  ]),
                  _vm._v(" "),
                  _vm._l(
                    _vm.deleteDatumDetails,
                    function (numMeasurements, station) {
                      return _c(
                        "v-card-text",
                        {
                          key: station,
                          staticStyle: {
                            "padding-bottom": "0px",
                            "padding-top": "0px",
                          },
                        },
                        [
                          _c("p", [
                            _c(
                              "span",
                              { staticStyle: { "font-weight": "bold" } },
                              [_vm._v(_vm._s(station))]
                            ),
                            _vm._v(
                              " containing " +
                                _vm._s(numMeasurements) +
                                " measurements"
                            ),
                          ]),
                        ]
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            disabled: _vm.deleteButtonDisabled,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.agreeDeleteDatum()
                            },
                          },
                        },
                        [
                          _c("v-icon", { staticClass: "mr-1" }, [
                            _vm._v("delete_forever"),
                          ]),
                          _vm._v(
                            _vm._s(_vm.$t("Button.DeleteDatum")) + "\n        "
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "secondary", outline: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                      ),
                    ],
                    1
                  ),
                ],
                2
              )
            : _c("v-card", [
                _c(
                  "div",
                  { staticClass: "text-xs-center" },
                  [
                    _c("v-progress-circular", {
                      attrs: { indeterminate: true },
                    }),
                  ],
                  1
                ),
              ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("AdministrationAddDatumDialog", {
        attrs: {
          show: _vm.showAddDatumDialog,
          datumList: _vm.datumList,
          name: _vm.tenantName,
        },
        on: {
          "update:datumList": function ($event) {
            _vm.datumList = $event
          },
          "update:datum-list": function ($event) {
            _vm.datumList = $event
          },
          refreshDatumList: _vm.populateDatumList,
        },
      }),
      _vm._v(" "),
      _c("AdministrationEditDatumDialog", {
        attrs: {
          show: _vm.showEditDatumDialog,
          datumList: _vm.datumList,
          datumDetail: _vm.datumDetail,
          name: _vm.tenantName,
        },
        on: {
          "update:datumList": function ($event) {
            _vm.datumList = $event
          },
          "update:datum-list": function ($event) {
            _vm.datumList = $event
          },
          refreshDatumList: _vm.populateDatumList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }